module.exports = __webpack_public_path__ + "img/Home-01.015a6f28.svg";